@import 'styles/mixins';
@import 'styles/variables';

.container {
  border-radius: 8px;
  max-width: 848px;

  .userAvatar {
    margin-right: 8px;
    margin-top: 3px;
    background-color: $navy-40;
  }

  .moreActions {
    &:active,
    &:hover {
      &:not(:disabled) {
        background: $gray-10;
      }
    }
  }
}

.userSection {
  margin-bottom: 40px;
}

.membersTable :global {
  .ant-table-column-title {
    @include sm-regular;
    color: $grey-40;
  }
  .ant-table-thead > tr > th {
    &:first-child {
      width: 250px;
    }
    background-color: transparent;
  }
  .ant-table-body {
    font-size: 13px;
  }
}

.membersTableRow {
  td {
    padding: 10px !important;
  }
  td:last-child {
    text-align: right !important;
  }
}

.nameCell {
  align-items: center;
  display: flex;
}

.nameCellText {
  @include md-medium;
  font-size: 13px;
  color: $grey-90;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 180px;
}

.emailCellText {
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 180px;
}

.newSectionTitle {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.sectionTitleText {
  @include lg-semibold;
  margin-right: 5px;
}

.sectionTitleCount {
  @include lg-regular;
}

.sectionTitle,
.showGuestsButton {
  @include header-label;
  color: $gray-40;
}

.actionsDropdownContent {
  @include z-index(antdPopover);
  background-color: $white;
  border: 1px solid $gray-20;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0px 1px 0px rgba(19, 21, 26, 0.12), 0px 2px 4px rgba(19, 21, 26, 0.06);
  min-width: 208px;
  padding: 8px;
}

.divider {
  height: 1px;
  background: $gray-20;
}

.action {
  @include ui-md-text;

  align-items: center;
  border-radius: 4px;
  color: $gray-90;
  display: flex;
  justify-content: space-between;
  margin: 4px 0;
  padding: 6px;

  &.active {
    background-color: $gray-5;

    svg {
      path {
        fill: $almanac-black;
      }
    }
  }
}

.showGuestsButton {
  display: flex;

  svg {
    margin-left: 6px;
    fill: $gray-40;
  }
}

.warning {
  margin-top: 10px;
  color: $red-60;
}

@include for-phone-only {
  .membersTable :global {
    .ant-table-thead > tr > th {
      &:first-child {
        width: 150px;
      }
    }
  }

  .nameCellText {
    @include line-clamp;
    width: 130px;
  }
}
